import { loginRoute } from "./login";
import { logoutRoute } from "./logout";
import { passwordRoute } from "./password";
import { testRoute } from "./test";

export default [loginRoute, logoutRoute, passwordRoute, testRoute];
